import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import { PopUpContext } from "../../contexts/popUpContext";

class TeacherBalancePopUp extends Form {
  static contextType = PopUpContext;

  state = {
    drp: {
      employees: [],
    },
    data: {
      amount: "",
      verified_by_staff_id: "",
      verification_date: "",
      remark: "",
      attachment: "",
    },
    errors: {},
  };

  componentDidMount = async () => {
    const { drp, data } = this.state;
    const { popUp } = this.context;

    if (popUp?.edit) {
      data.amount = popUp.edit.data.amount;
      data.verified_by_staff_id = popUp.edit.data.verified_by_staff_id;
      data.verification_date = popUp.edit.data.verification_date;
      data.remark = popUp.edit.data.remark;
    }

    await db
      .getAll(`dropdowns/staff?sectionId=1`)
      .then(({ data: { data } }) => (drp["employees"] = data));

    this.setState({ drp, data });
  };

  schema = {
    amount: Joi.number().required(),
    verified_by_staff_id: Joi.number().required(),
    verification_date: Joi.date().required(),
    remark: Joi.string().required(),
    attachment: Joi.allow(null).allow(""),
  };

  doSubmit = async ({ target }) => {
    try {
      const { togglePopUp, popUp } = this.context;

      const __controls = this.cleanObject({
        teacher_id: popUp.cache ? popUp.cache : popUp.edit.data.teacher_id,
        ...this.state.data,
      });

      await db
        .form("teachers/balance", target, __controls, popUp?.edit?.data?.id)
        .then((e) => {
          togglePopUp({ form: "toast" });
        })

        .catch((err) => {
          togglePopUp({
            form: "toast",
            message: err.toString(),
            type: "warning",
          });
        });
    } catch ({ response }) {
      if (response && response.status === 400) {
        const errors = { ...this.state.error };

        this.setState({ errors });
      }
    }
  };

  render() {
    const { drp } = this.state;
    const { popUp } = this.context;

    return (
      <div className="form-container">
        <form className="form crud" onSubmit={this.handleSubmit}>
          <div className="head">
            <p>
              {popUp?.edit ? lbl.EditOpeningBalance : lbl.SaveOpeningBalance}
            </p>
          </div>
          <div className="form-inputs">
            {this.renderInput("amount", "مبلغ", "number")}
            {this.renderSelect(
              "verified_by_staff_id",
              "تایید کننده",
              drp["employees"]
            )}
            {this.renderInput("verification_date", "تاریخ ارزیابی", "date")}
            {this.renderInput("remark", "ملاحظه", "textarea")}
            {this.renderFile("attachment", "سند")}
          </div>
          <div className="form-buttons">
            {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
          </div>
        </form>
      </div>
    );
  }
}

export default TeacherBalancePopUp;
